import React from 'react'

const WriteForUs = () => {
  return (
    <div>
      write for us
    </div>
  )
}

export default WriteForUs
